// extracted by mini-css-extract-plugin
export var icon = "_9a-3";
export var subtitle = "_9a-2";
export var title = "_9a-1";
export var value = "_9a-0";